<template>
  <div>{{ data.text }}</div>
  <v-row justify="center">
    <v-col v-for="(radio, index) in data.props" :key="index" cols="12" :md="data.props.length== 2 ? 6 : 4" class="flex-center">
      <v-radio-group :name="data.name" v-model="value">
        <v-radio :label="radio.text" :value="radio.value" ></v-radio>
      </v-radio-group>
    </v-col>
  </v-row>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CheckboxComponent',
  props: {
    data: Object,
    baseValue: [Object, String, Array, Boolean],
  },
  data: (props) => {
    return {
      value: props.baseValue,
    }
  },
  emits: ['formModEvent'],
  watch: {
    value() {
      this.sendDataToParent()
    },
  },
  methods: {
    sendDataToParent() {
      const dataToSend = [
        {
          key: this.data.name,
          value: this.value,
        },
      ]
      this.$emit('formModEvent', dataToSend)
    },
  },
})
</script>


<style lang="css" scoped>
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>